module.exports = __webpack_public_path__ + "media/images/icon_a5_blue-b9b9d936a8c43388c4b8a68f7e5a80c3.png";